import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Box } from 'shared/mui/Box';
import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { TextInputIntrospected } from 'shared/react-admin/Inputs';
import { CreateGuesserPage } from 'shared/react-admin/Pages/CreateGuesserPage/CreateGuesserPage';

export const CompaniesCreate = () => {
  const translate = useTypedTranslate();

  return (
    <CreateGuesserPage
      listName={translate('app.companies.titleText')}
      mutationOptions={{
        onError: () => undefined,
      }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButton key="save-button" />,
      ]}
      title={translate('app.companies.createTitle')}
    >
      <Box py="24px" width="100%">
        <TextInputIntrospected
          fullWidth
          helperText={false}
          label={translate('app.table.name')}
          size="small"
          source="name"
          variant="outlined"
        />
      </Box>
    </CreateGuesserPage>
  );
};
